import { useQuery } from "@tanstack/react-query";
import { fetchArea } from "src/Pages/Company/OrganizationStructure/api";
import { IArea } from "src/Pages/Company/OrganizationStructure/Areas/Area.models";

const useFetchArea = ({
  companyId,
  structureId,
  areaId,
  enabled,
  queryParams,
}: {
  companyId: string | undefined;
  structureId: string | undefined;
  areaId: string | undefined;
  enabled?: boolean;
  queryParams?: Record<string, string>;
}) =>
  useQuery<IArea, Error>({
    enabled,
    queryKey: ["area-data", companyId, structureId, areaId, queryParams],
    queryFn: async ({ signal }) =>
      fetchArea(companyId!, structureId!, areaId!, {
        signal,
        queryParams,
      }),
  });

export default useFetchArea;
